import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ButtonActionComponent } from '../../../controls/container/button-action/button-action.component';
import { ButtonsRowComponent } from 'src/app/features/shared/controls/container/buttons-row/buttons-row.component';
import { IChoice, IChoiceDialogData } from '../../models/choice';
import { SharedModule } from '../../../shared.module';

@Component({
    selector: 'app-choice-dialog',
    templateUrl: './choice-dialog.component.html',
    styleUrls: ['./choice-dialog.component.scss'],
    standalone: true,
    imports: [
        SharedModule,
        ButtonActionComponent,
        ButtonsRowComponent,
    ],
})
export class ChoiceDialogComponent<T = unknown> {
    private readonly __dialogRef = inject<MatDialogRef<ChoiceDialogComponent<T>, T>>(MatDialogRef);
    protected readonly _data = inject<IChoiceDialogData<T>>(MAT_DIALOG_DATA);

    emit_select(choice: IChoice<T>): void {
        this.__dialogRef.close(choice.value);
    }
}
